"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.logout = void 0;
const logout_1 = require("./apis/logout");
const config_1 = require("../utils/config");
const cookieManager_1 = require("../utils/cookieManager");
const eventManager_1 = require("../utils/eventManager");
const session_1 = require("./apis/session");
const newRelicEvents_1 = require("../utils/newRelicEvents");
const broadcastChannel_1 = require("../utils/broadcastChannel");
function logout() {
    return __awaiter(this, void 0, void 0, function* () {
        if (config_1.getDomain()) {
            cookieManager_1.removeCookies(config_1.getDomain());
        }
        try {
            newRelicEvents_1.sendNewRelicEvent({ EventName: 'logout_start' });
            yield Promise.all([logout_1.logout(), session_1.disposeSession()]);
            newRelicEvents_1.sendNewRelicEvent({ EventName: 'logout_success' });
            const channel = broadcastChannel_1.getBroadcastChannel();
            if (channel) {
                channel.postMessage({ action: 'logout' });
            }
            eventManager_1.emit('logout.success');
        }
        catch (e) {
            newRelicEvents_1.sendNewRelicEvent({ EventName: 'logout_failed', error: e });
            eventManager_1.triggerError('logout', e);
        }
    });
}
exports.logout = logout;
